import React, { useEffect, useState } from "react";
import { FaPlus, FaEllipsisVertical, FaEye, FaPen } from "react-icons/fa6";
import { MdDelete } from "react-icons/md";
import { handleRowsPerPage } from "../../../controls/Pagination/Pagination";
import moment from "moment";

import { Header, DataTable } from "../../../common";
import {
  ButtonView,
  CardView,
  Input,
  Select,
  ModalView,
} from "../../../controls";
import { MdSearch } from "react-icons/md";
//
import "./InstagramManagementStyles.scss";
import { history } from "../../../../store/configure/configureStore";

const InstagramManagementView = ({
  //
  instagramList,
  showRowsPerPage,
  //
  currentPage,
  //
  handleTableRowsChange,
  handleChangePage,
  //
  onChangeSearchInput,
  onClickSearch,
  //
  rowsPerPageDropDownOptions,
}) => {
  // console.log(instagramList);

  //
  const columns = [
    {
      name: "Title",
      grow: 3,
      selector: (row) => row?.caption || "-",
    },
    {
      name: "Created On",
      grow: 3,
      selector: (row) => {
        return moment(row?.createdAt).format("DD/MM/YYYY") || "-";
      },
    },
    {
      name: "Content Type",
      grow: 3,
      selector: (row) => row?.mediaType || "-",
    },
    {
      name: "Category",
      grow: 3,
      center: true,
      selector: (row) => {
        return row && row.categoryId && row.categoryId[0]
          ? row.categoryId[0].categoryName
          : "-";
      },
    },
    {
      name: "Status",
      grow: 3,
      selector: (row) => row?.status[0]?.status || "-",
    },
    {
      name: "Action",
      grow: 1,
      center: true,
      cell: (row, rowIndex) => renderAction(row, rowIndex),
      // cell: (row) => <FaEye />,
    },
  ];

  //--------------------------action UI

  const renderAction = (row, rowIndex) => {
    return (
      <div>
        <FaEye
          color="#B6C7AA"
          className="action-btn"
          onClick={() =>
            history.push(`/media/content-detail/instagram?id=${row._id}`)
          }
        />
      </div>
    );
  };

  useEffect(() => {}, []);
  return (
    <div className="instagram__management--container">
      <div className="instagram__management--header-wrapper">
        <div className="title-content">Instagram Management</div>
      </div>
      <div className="instagram__management--table-wrapper">
        <div className="controls-wrapper">
          <div className="row-control-wrapper">
            <Select
              // value={showRowsPerPage}
              placeholder={"10"}
              options={rowsPerPageDropDownOptions}
              onChange={(val) => handleTableRowsChange(val)}
              isRowCap={true}
            />
            entries per page
          </div>
          <div className="row-control-wrapper">
            Search:{" "}
            <Input
              placeholder={"Type here to search"}
              onChange={(e) => onChangeSearchInput(e)}
            />
            <div className="search-action-wrapper">
              <ButtonView
                // title="Search"
                icon={<MdSearch size={20} color="#eca55a" />}
                styles={"secondary"}
                size={"medium btn"}
                onClick={() => onClickSearch()}
              />
            </div>
          </div>
        </div>
        <div className="table-content">
          <DataTable
            columns={columns}
            data={instagramList?.docs ? instagramList?.docs : []}
            highlightOnHover={true}
            pointerOnHover={true}
            fixedHeader={true}
            //
            pagination={true}
            paginationServer={true}
            paginationPerPage={instagramList?.limit}
            paginationTotalRows={instagramList?.totalDocs}
            onChangeRowsPerPage={handleTableRowsChange}
            onChangePage={handleChangePage}
            currentPage={currentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default InstagramManagementView;
